export default __webpack_public_path__ + "static/media/icon-phone-cycle.6928e017.svg";